import { createReducer, on } from '@ngrx/store';
import { 
  InviteUserAction, 
  InviteUserFailedAction, 
  InviteUserSuccessAction, 
  InvitationsListLoadedAction, 
  TeamMemberOnlineEventAction, 
  UpdateUserAction, 
  UpdateUserFailedAction, 
  UpdateUserSuccessAction,
  FetchBlockedUsersListAction,
  BlockedUsersListLoadedAction,
  BlockedUsersListFailedToLoad,
  BlockUserAction,
  BlockUserSuccessAction,
  BlockUserFailedAction,
  UnblockUserAction,
  UnblockUserSuccessAction,
  UnblockUserFailedAction
} from './action';
import { TeamMemberOnlineEventDto } from '@/app/Data/DTO/Team/TeamMemberOnlineEventDto';
import { UserInvitation, User } from '@/app/core/Models/User';

export interface UsersState {
  invitations: UserInvitation[];
  onlineMembers: TeamMemberOnlineEventDto[];
  creatingUser: boolean;
  updatingUser: boolean;
  blockedUsers: User[];
  blockingUser: boolean;
}

export const initUsersState: UsersState = {
  invitations: [],
  onlineMembers: [],
  creatingUser: false,
  updatingUser: false,
  blockedUsers: [],
  blockingUser: false
};

export const usersReducer = createReducer(
  initUsersState,
  on(TeamMemberOnlineEventAction, (state: UsersState, { payload }) => {
    return {
      ...state,
      onlineMembers: state.onlineMembers
        .filter((obj) => obj?.user_id !== payload?.user_id)
        .concat(payload),
    };
  }),
  /* ---------------------------- invitatios loaded --------------------------- */
  on(InvitationsListLoadedAction, (state: UsersState, { payload }) => {
    return {
      ...state,
      invitations: payload 
    };
  }),
  /* ------------------------------- create user ------------------------------ */
  on(InviteUserAction, (state: UsersState, { payload }) => {
    return {
      ...state,
      creatingUser: true
    };
  }),
  on(InviteUserSuccessAction, (state: UsersState) => {
    return {
      ...state,
      creatingUser: false
    };
  }),
  on(InviteUserFailedAction, (state: UsersState) => {
    return {
      ...state,
      creatingUser: false
    };
  }),
  /* ------------------------------- update user ------------------------------ */
  on(UpdateUserAction, (state: UsersState, { payload }) => {
    return {
      ...state,
      creatingUser: true
    };
  }),
  on(UpdateUserSuccessAction, (state: UsersState) => {
    return {
      ...state,
      creatingUser: false
    };
  }),
  on(UpdateUserFailedAction, (state: UsersState) => {
    return {
      ...state,
      creatingUser: false
    };
  }),
  /* ------------------------------- blocked users ------------------------------ */
  on(FetchBlockedUsersListAction, (state: UsersState) => {
    return {
      ...state,
      blockedUsers: []
    };
  }),
  on(BlockedUsersListLoadedAction, (state: UsersState, { payload }) => {
    return {
      ...state,
      blockedUsers: payload
    };
  }),
  on(BlockedUsersListFailedToLoad, (state: UsersState) => {
    return {
      ...state,
      blockedUsers: []
    };
  }),
  /* ------------------------------- block user ------------------------------ */
  on(BlockUserAction, (state: UsersState) => {
    return {
      ...state,
      blockingUser: true
    };
  }),
  on(BlockUserSuccessAction, (state: UsersState) => {
    return {
      ...state,
      blockingUser: false
    };
  }),
  on(BlockUserFailedAction, (state: UsersState) => {
    return {
      ...state,
      blockingUser: false
    };
  }),
  /* ------------------------------- unblock user ------------------------------ */
  on(UnblockUserAction, (state: UsersState) => {
    return {
      ...state,
      blockingUser: true
    };
  }),
  on(UnblockUserSuccessAction, (state: UsersState) => {
    return {
      ...state,
      blockingUser: false
    };
  }),
  on(UnblockUserFailedAction, (state: UsersState) => {
    return {
      ...state,
      blockingUser: false
    };
  }),
);

